import { useEffect, useRef } from 'react'

const currentVersion = __APP_VERSION__

/**
 * Hook that checks for new versions on navigation.
 * When a new version is detected, the page reloads seamlessly.
 */
export function useVersionCheck() {
	const isFirstRender = useRef(true)

	useEffect(() => {
		// Skip the initial render - no need to check on first load
		if (isFirstRender.current) {
			isFirstRender.current = false
			return
		}

		const checkVersion = async () => {
			try {
				const response = await fetch('/version.json', {
					cache: 'no-cache',
				})
				if (!response.ok) return

				const data = await response.json()
				if (data.version && data.version !== currentVersion) {
					window.location.reload()
				}
			} catch {
				// Silently fail - network issues shouldn't break the app
			}
		}

		checkVersion()
	}, [])
}
